__turbopack_context__.v({
  "css-iemeck-container": "dropdown-module-scss-module__0x4s2G__css-iemeck-container",
  "css-zapfv0-control": "dropdown-module-scss-module__0x4s2G__css-zapfv0-control",
  "dropdown-container": "dropdown-module-scss-module__0x4s2G__dropdown-container",
});
